"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var palette = _ref.palette,
    shadows = _ref.shadows,
    typography = _ref.typography;
  return {
    root: {
      display: 'flex',
      backgroundColor: '#fff',
      boxShadow: shadows[1],
      overflow: 'hidden',
      width: '320px',
      minHeight: 60
    },
    iconWrapper: function iconWrapper(props) {
      return {
        fontSize: '1.6rem',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
        width: '75px',
        backgroundColor: palette[props.type].main
      };
    },
    content: {
      display: 'flex',
      flex: '1 1 auto',
      padding: '10px 15px 10px 10px',
      justifyContent: 'space-between',
      fontWeight: typography.fontWeightRegular
    },
    header: {
      display: 'flex',
      flexDirection: 'column'
    },
    title: {
      flex: '1 1 auto',
      fontSize: '13px',
      marginBottom: '5px'
    },
    close: {
      flex: '0 0 auto',
      color: 'black',
      fontSize: '20px',
      cursor: 'pointer'
    },
    message: {
      lineHeight: 1.4,
      fontSize: '14px',
      whiteSpace: 'pre-wrap'
    }
  };
}, {
  name: 'Snackbar'
});
exports.useStyles = useStyles;